<template>
  <div class="d-flex flex-column">
    <div
      v-if="['idle', 'progress'].includes(removeSignStatus)"
      class="pa-0 text-black mb-4"
    >
      <I18nT keypath="dialogs.document_dialog.subtitles.remove_approver" />
    </div>
    <v-alert
      v-if="removeSignStatus === 'error'"
      class="mb-6 text-body-small"
      data-test-id="deep-sign-alert"
      type="error"
      variant="tonal"
    >
      <I18nT keypath="errors.remove_approver_error" />
    </v-alert>

    <portal to="document-dialog-actions">
      <VBtnSecondary @click="emit('closeDialog')">
        <I18nT keypath="buttons.close" />
      </VBtnSecondary>
      <VBtnPrimary
        v-if="['idle', 'progress'].includes(removeSignStatus)"
        ref="removeSigneeButton"
        @click="removeApprover"
      >
        <I18nT keypath="buttons.remove_approver" />
      </VBtnPrimary>
    </portal>
  </div>
</template>
<script setup lang="ts">
import I18nT from '@/components/I18nT.vue';
import { ref } from 'vue';
import { useSignStore } from '@/stores/sign.ts';
import { useGlobalStore } from '@/stores/global.ts';
import { useMessageStore } from '@/stores/message.ts';
import { useI18n } from 'vue-i18n';
import type { ComponentState } from '@/types/ui';
import { onMounted } from 'vue';
import { nextTick } from 'vue';
import { useDocumentContext } from '@/composables/useDocumentContext.ts';
import { useEmitter } from '@/composables/useEmitter.ts';

const emit = defineEmits(['closeDialog']);
const { currentDocument } = useDocumentContext();

const signStore = useSignStore();
const globalStore = useGlobalStore();
const messageStore = useMessageStore();
const i18n = useI18n();
const removeSignStatus = ref<ComponentState>('idle');
const removeSigneeButton = ref();
const emitter = useEmitter();

async function removeApprover() {
  try {
    removeSignStatus.value = 'progress';
    if (
      currentDocument.value &&
      currentDocument.value.documentId &&
      globalStore.selectedSignee?.signeeId
    ) {
      await signStore.removeSignee(
        currentDocument.value.documentId,
        globalStore.selectedSignee?.signeeId
      );
      removeSignStatus.value = 'success';
      messageStore.showMessage({
        text: i18n.t('snackbars.approver_removed'),
        color: 'success',
        icon: 'fa fa-circle-check'
      });
      emitter.$emit('update-sign-status');
      emit('closeDialog');
    } else {
      removeSignStatus.value = 'error';
    }
  } catch (error) {
    removeSignStatus.value = 'error';
  }
}

onMounted(() => {
  nextTick(() => {
    removeSigneeButton.value.$el.focus();
  });
});
</script>
